import { Component, Injectable } from '@angular/core';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { Token } from "../../model/token";
import { ConfiguracionDTO } from '../../model/configuracion.dto';
import { Session } from '../../model/session';
import { Combo } from '../../model/combo';


/*Singleton para acceso a los datos de configuracion general */
@Injectable()
export class ConfigurationControlService {

  /* Objeto encargado de manejar la configuracion  global de PLEXI*/
  public examConfiguration: ConfiguracionDTO;

  /* Variable para identificar si se descargaron archivos luego de finalziar */
  public downloadFile: Boolean;

  /*Contiene la ip desde donde se presenta el examen*/
  public publicIp: string;

  /*Contiene la credencial para manejo de sesionInfo*/
  public credencial: number;

  /**Contiene la información de la sesion actual */
  public sessionInfo: Session | null = null;

  /** Bandera que identifica si el examen es demo */
  public esDemo: Boolean;

  /** Indica si debe iniciar el cronómetro */
  public startChrono: Boolean;

  /** Representa la url Actual */
  public urlActual: string;

  /** Bandera que identifica si el examen es demo */
  public ambiente: string;

  /** Flag para conexion con los servicios */
  public online: Boolean;

  /** Representa el id de la Prueba Actual */
  public idPrueba: any;

  /** Representa las pruebas disponibles */
  public pruebasDisponibles: Combo[];

  /** Representa el tipo y numero de documento para preIfces */
  public documento: string;

  /** Flag para habilitar accesibilidad de fuente */
  public habilitarFuente: Boolean;

  /** Flag para habilitar accesibilidad de audio */
  public habilitarAudio: Boolean;

  /** Flag para habilitar accesibilidad de contraste */
  public habilitarContraste: Boolean;

  /** flag para identificar si continua el examen */
  public continuarExamen: Boolean;

  /** Flag para habilitar toolKit */
  public showToolKit: Boolean;

  /** arreglo que contiene los eventos apilados en offline */
  public sessionEventPile: any[] = [];

  /** arreglo que contiene el inicio y fin del cronometro en la prueba offline */
  public chronoStartAndEnd: any[] = [];

  /** indica si debe tener o no captcha activado */
  public showCaptcha: Boolean;

  /**limite del tam en MB del archivo en item files */
  public tamFile: number;

  /**Indica para el Tour de ayuda si al finalizar muestra el welcome */
  public tourWelcome = false;

  /**limite del timeout para los servicios */
  public timeoutService: number = 30000;

  /**limite del timeout para los servicios */
  public stopIntervalFlag: Boolean = false;

  /**limite de reintentos para llamado al servicio lambda */
  public reintentosServiceLambda: number;

}
